module.exports = __webpack_public_path__ + "img/gold.93f528f3.png";